import IMask from 'imask';

export default class TimePicker {
    constructor($el) {
        this.$el = $el;
        this.completeValue = this.completeValue.bind(this);

        if (!this.$el.getAttribute('inputmode')) {
            this.$el.setAttribute('inputmode', 'numeric');
        }

        if (!this.$el.getAttribute('placeholder')) {
            this.$el.setAttribute('placeholder', 'HH:MM');
        }

        this.mask = IMask(this.$el, {
            mask: 'HH:MM',
            overwrite: true,
            blocks: {
                HH: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 23,
                    maxLength: 2,
                    autofix: 'pad',
                },
                MM: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59,
                    maxLength: 2,
                    autofix: 'pad',
                },
            },
        });

        this.$el.addEventListener('blur', this.completeValue);
    }

    completeValue() {
        const value = this.mask.unmaskedValue;

        if (!value || this.mask.masked.isComplete) {
            return;
        }

        const hours = value.slice(0, 2).padStart(2, '0');
        const minutes = value.length > 2
            ? value.slice(2, 4).padStart(2, '0')
            : '00';

        this.mask.value = `${hours}:${minutes}`;
    }
}
